import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import { styled } from 'styled-components';
import SkuLocationSection from './SkuLocation/SkuLocationSection';
import ScannerControl from './ScannerControl/ScannerControl';
import B2CQueueSection from './B2CQueue/B2CQueueSection';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { configThunks, selectSettingsAvailable } from 'store/reducers/configSlice';
import { useEffect } from 'react';

const Admin = () => {
    const dispatch = useAppDispatch();
    const settingsAvailable = useAppSelector(selectSettingsAvailable);

    useEffect(() => {
        if (!settingsAvailable.isAvailable && !settingsAvailable.isLoading) {
            dispatch(configThunks.getReturnCenterSettings());
        }
    }, [dispatch, settingsAvailable]);

    return (
        <Wrapper column $grow={1} gap="1rem">
            <Text className="f3-700 mb-0" fontSize={20} as="h1">
                Admin
            </Text>
            <ScannerControl />
            <SkuLocationSection />
            <B2CQueueSection />
        </Wrapper>
    );
};

export default Admin;

const Wrapper = styled(Flex)`
    padding: 1rem;

    @media (min-width: 1515px) {
        padding: 1rem 0 0 0;
    }
`;
